
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IUpdateEmailModel } from '@/models/account.model';

  import accountService from '@/services/account.service';
  import tokenService from '@/services/token.service';
  import routeService from '@/services/route.service';
  import userService from '@/services/user.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'isLoading'
      ])
    }
  })
  export default class UpdateEmail extends Vue {
    data() {
      return {
        studio: '',
        hasErrors: false,
        isUpdateLoading: false,
        errors: new Array<IErrorModel>(),
        form: {} as IUpdateEmailModel
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;

      if (tokenService.hasToken(this) == null) {
        routeService.redirectToLogin(this, this.$router.currentRoute.path);
      }
    }

    updateEmail() {
      if (this.$data.isUpdateLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isUpdateLoading = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasErrors = false;

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "profile/user/" + this.$store.getters.user.Id + "/update-email";

        accountService.post<IUpdateEmailModel, object>(this, url, this.$data.form, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isUpdateLoading = false;
            userService.updateUser(this, false, false, this.$store.getters.user.Id, this.$store.getters.token.Value, undefined, true);
          })
          .catch(error => {
            this.$data.hasErrors = true;
            this.$data.errors = error.data.ErrorMessages;
            this.$data.isUpdateLoading = false;
            this.$store.dispatch("updateIsLoading", false);
          });
      }, 300);
    }

    updateFormValue(parameter: string, value: string) {
      this.$set(this.$data.form, parameter, value);
    }
  }
